import enUS from './en-US'
import gr from './el-GR'

export default {
  'en-US': enUS,
  'el-GR': gr,
}
